import React, { useEffect, useState } from "react";
import { SalesInvoiceRo } from "../../../Redux/roStore";
import {
  SalesInvoice_deleteRMADetails_GETROW,
  SalesInvoice_getRMiDetails_GETROW,
  SalesInvoice_invTransDetailBatchIssue_GETROW,
  SalesInvoice_UpdateRMADetails_GETROW,
} from "../../../Server/ApiV2";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
} from "../../../Utility/Utilitys";
import moment from "moment";
import GCRegisterSerialNumberModal from "../../../Component/Common/ReuseableComponent/GCRegisterSerialNoModal";
import { sTrnTyp } from "../SalesInvoiceAction";

const RegisterSerialNumberModal = ({
  open,
  handleClose,
  SrNo,
  ItemCd = "",
  xDisable
}) => {
  const [autoSave, setAutoSave] = useState(false);
  const [serialNumber, setSerialNumber] = useState("");
  const [selectedSerialNumbers, setSelectedSerialNumbers] = useState([]);
  const [sDocument, setDocumentRow] = useState([]);
  const [selectedRowIds, setSelectedRowIds] = useState([]); // Track multiple selected row IDs

  const handleSerialChange = (e) => setSerialNumber(e.target.value);

  const handleAutoSaveToggle = () => setAutoSave(!autoSave);

  const fSrNo = async () => {
    const { HeadObject } = SalesInvoiceRo();
    const payload = {
      v_C_VocTyp: HeadObject.A_VocTyp,
      v_C_VocNo: HeadObject.A_VocNo,
      v_C_SrNo: SrNo,
    };

    let resp = await SalesInvoice_getRMiDetails_GETROW(
      fcheck_null_undefine_replace_empty(payload)
    );

    if (resp?.status === 200) {
      let respData =
        resp?.data?.ResultSet.map((obj, i) => ({
          ...obj,
          id: i + 1,
        })) || [];
      setSelectedSerialNumbers(respData);
    } else {
      setSelectedSerialNumbers([]);
    }
  };

  const fOnLoad = async () => {
    const { HeadObject } = SalesInvoiceRo();
    const payload = {
      v_TrnTyp: sTrnTyp,
      v_VocTyp: HeadObject.A_VocTyp,
      v_VocNo: HeadObject.A_VocNo,
      v_SrNo: SrNo,
    };
    let resp = await SalesInvoice_invTransDetailBatchIssue_GETROW(
      fcheck_null_undefine_replace_empty(payload)
    );
    if (resp?.status === 200) {
      let respData =
        resp?.data?.ResultSet.map((obj, i) => ({
          ...obj,
          id: i + 1,
        })) || [];
      setDocumentRow(respData);
      fSrNo()
    } else {
      setDocumentRow([]);
    }
  };

  useEffect(() => {
    if (open) {
      setSelectedRowIds([])
      fOnLoad();
    }
  }, [open]);

  return (
    <GCRegisterSerialNumberModal
    
    xDisable={xDisable}
      open={open}
      handleClose={handleClose}
      autoSave={autoSave}
      setAutoSave={setAutoSave}
      serialNumber={serialNumber}
      setSerialNumber={setSerialNumber}
      selectedSerialNumbers={selectedSerialNumbers}
      setSelectedSerialNumbers={setSelectedSerialNumbers}
      selectedRowIds={selectedRowIds}
      setSelectedRowIds={setSelectedRowIds} // Pass the setter for selected row IDs
      handleSerialChange={handleSerialChange}
      handleAutoSaveToggle={handleAutoSaveToggle}
      handleSave={async () => {
        const { HeadObject } = SalesInvoiceRo();

        if (serialNumber === "") {
          fAlertToast("FAILED", "Enter serial number");
          return;
        }

        // Check for duplicate serial numbers
        let duplicateSerial = selectedSerialNumbers.find(
          (obj) => serialNumber === obj.C_BatchNo
        );
        if (duplicateSerial) {
          fAlertToast("FAILED", "Serial number already saved");
          return;
        }

        const payload = {
          v_C_VocTyp: HeadObject.A_VocTyp,
          v_C_VocNo: HeadObject.A_VocNo,
          v_C_SrNo: SrNo,
          v_C_ItmCd: ItemCd,
          v_C_Qty: 1,
          v_C_Unit: "",
          v_C_BaseQty: 1,
          v_C_Narr: "",
          v_C_BatchNo: serialNumber,
          v_C_BatchDt: "01/01/1900",
          v_C_ExpDt: "01/01/1900",
          v_C_PTyp1: "",
          v_C_PTyp2: "",
          v_C_PTyp3: "",
          v_C_PTyp4: 0,
          v_C_PTyp5: 0,
          v_C_PTyp6: 0,
          v_C_RowID: 0,
        };

        let resp = await SalesInvoice_UpdateRMADetails_GETROW(
          fcheck_null_undefine_replace_empty(payload)
        );
        if (resp?.status === 200) {
          fAlertToast("SUCCESS", "Successfully Saved");
          setSerialNumber(""); // Clear serial number input
          await fSrNo(); // Reload Serial Numbers after save
        }
      }}
      handleDelete={async () => {
        if (selectedRowIds.length === 0) {
          fAlertToast("FAILED", "Select at least one row to delete");
          return;
        }

        const { HeadObject } = SalesInvoiceRo();
        const payload = selectedSerialNumbers
          .filter((row) => selectedRowIds.includes(row.id)) // Filter only selected rows for deletion
          .map((row) => ({
            v_C_SrNo: SrNo,
            v_C_RowID: row.C_RowId
            ,
          }));

     
        let resp = await SalesInvoice_deleteRMADetails_GETROW(
          fcheck_null_undefine_replace_empty({ 
              v_C_VocTyp: HeadObject.A_VocTyp,
            v_C_VocNo: HeadObject.A_VocNo,
            rmaDetailsArray: payload })
        );
        if (resp?.status === 200) {
          fAlertToast("SUCCESS", "Successfully Deleted");
          setSerialNumber(""); 
          await fSrNo(); // Reload Serial Numbers after deletion
        }
      }}
      Document={sDocument}
      DocumentColumn={[
        { field: "B_Srno", headerName: "Srno", width: 90 },
        { field: "B_Itmcd", headerName: "Item Code", width: 150 },
        { field: "ItmName", headerName: "Item Name", width: 250 },
        { field: "B_Qty", headerName: "Qty", width: 100 },
        { field: "UnitName", headerName: "Unit", width: 100 },
        { field: "B_BaseQty", headerName: "BaseQty", width: 100 },
      ]}
      SrNoColumn={[
        { field: "C_BatchNo", headerName: "Batch No", width: 150 },
        { field: "C_BatchDt", headerName: "MFD", width: 90 },
        { field: "C_ExpDt", headerName: "EXP", width: 90 },
        { field: "Qty", headerName: "BaseQty", width: 90 },
      ]}
    />
  );
};

export default RegisterSerialNumberModal;
